import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Plato } from 'src/app/models/plato';
import { Restaurante } from 'src/app/models/restaurante';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { PlatosService } from 'src/app/services/platos.service';
import { ProductoService } from 'src/app/services/producto.service';
import { FollowService } from 'src/app/services/follow.service';
import { GLOBAL } from '../../../services/global';
import { Tags } from 'src/app/models/tags';
import { Producto } from 'src/app/models/producto.model';
import { Router } from '@angular/router';
import { MetricaService } from 'src/app/services/metrica.service';
import { result } from 'lodash';

@Component({
  selector: 'app-pagina-plato',
  templateUrl: './pagina-plato.component.html',
  styleUrls: ['./pagina-plato.component.css']
})
export class PaginaPlatoComponent implements OnInit {
  arrayBotones = [];
  restauranteModel: any;
  urlResources = GLOBAL.urlResourcesCarta;
  urlIcons = GLOBAL.urlIcons;
  url = "";
  closeResult: string;
  tagsMarca = [];
  tagsNormal = [];
  alergenos = [];
  newTagNormal: string;
  listTagNormal = [];
  tempMarca: any[];
  tempRelFabMarca: [string, number];
  tempNormal: any[];
  follows: string;
  fotoPortada: string;
  nombreRest: string;
  direccionRest: string;
  userLogin: any;
  idPlato: number;
  idProducto: number;
  resultInsertFollow: any;
  cartaQR: boolean = false;
  follow: boolean = false;
  followRestaurant: boolean = false;
  resultInsertFollowRestaurant: any;
  slugRest: any;
  otros_hashtag: any;
  restauranteClickcado: string = '';
  marcaId: string = '';
  platoClickcado: string = '';
  idUsuario?: string;
  urlContactoWhatsapp: string = "";
  pos: any = null;
  posRestaurante: any = null;
  pantallaCarga: boolean = false;
  lang: string = "en";
  diasSemana = [
    'lunes',
    'martes',
    'miercoles',
    "jueves",
    "viernes",
    "sabado",
    "domingo"
  ];
  diaSemanaHoy: any = 0;
  @Input() plato: any;
  @Input() establecimiento: any;

  @ViewChild("btnLike", null) btnLike: { nativeElement: any; }


  constructor(
    private route: ActivatedRoute,
    private pService: PlatosService,
    private prService: ProductoService,
    private fService: FollowService,
    private modalService: NgbModal,
    private router: Router,
    private mService: MetricaService,
  ) {
  }

  ngOnInit() {
    this.userLogin = JSON.parse(localStorage.getItem("user"));
    this.url = GLOBAL.url;
    this.fotoPortada = '';
    this.nombreRest = '';
    this.direccionRest = '';
    this.lang = navigator.language.split('-')[0];

    const hoy = new Date();
    this.diaSemanaHoy = hoy.getDay() - 1;

    if (this.diaSemanaHoy < 0) {
      this.diaSemanaHoy = 6;
    }

    this.route.params.subscribe(result => {

      const addFavorite = this.route.snapshot.queryParams['addFavorite'];
      const nombreMarca = this.route.snapshot.queryParams['nombreMarca'];
      if (addFavorite) {

        this.fService.insertarFollowenLogin(addFavorite, nombreMarca, this.plato.slug).subscribe(result => {
          localStorage.setItem('nombreMarca', '');
          localStorage.setItem('slug', '');
        });
      }
    });

    this.route.queryParamMap.subscribe((params) => {
      if (params.get('nombreMarca') != null && params.get('nombreMarca') != "") {

        if (params.get('restauranteClickcado') != null && params.get('restauranteClickcado') != "") {
          this.restauranteClickcado = params.get('restauranteClickcado');
        }

        if (params.get('marcaId') != null && params.get('marcaId') != "") {
          this.marcaId = params.get('marcaId');
        }

        if (params.get('platoClickcado') != null && params.get('platoClickcado') != "") {
          this.platoClickcado = params.get('platoClickcado');
        }

        this.addMetricaMapaMarca();
      }
    });

    //Comprobamos el botón del like

    this.formatearDatosPlato();

  }

  convertirSaltosDeLinea(texto) {
    return texto.replace(/\r\n|\r|\n/g, '<br>');
  }

  addMetricaMapaMarca() {

    let modeloMetrica = {
      mapa_marca_id: this.marcaId,
      articulo_id: this.platoClickcado,
      establecimiento_id: this.restauranteClickcado
    }

    modeloMetrica["tipo_interaccion"] = 2;

    this.mService.addMetrica(modeloMetrica).subscribe(result => {
      if (result.result == "ok") {
        console.log("Click guardada en metrica");
      } else {
        console.log("Error a la hora de guardar en metrica");
      }
    });

    modeloMetrica["tipo_interaccion"] = 4;

    this.mService.addMetrica(modeloMetrica).subscribe(result => {
      if (result.result == "ok") {
        console.log("Destino Ok guardada en metrica");
      } else {
        console.log("Error a la hora de guardar en metrica");
      }
    });
  }

  navegar(direccion) {
    this.router.navigate([direccion]);
  }

  formatearDatosPlato() {

    this.plato = JSON.parse(JSON.stringify(this.plato));

    this.tempMarca = [];
    this.tempNormal = [];

    this.plato.descripcion = (this.plato.descripcion !== 'null') && (this.plato.descripcion !== null) ? JSON.parse(this.plato.descripcion)[0].data : '';
    let temp = this.plato.tags ? JSON.parse(this.plato.tags) : 0;

    for (let i = 0; i < temp.length; i++) {
      if (temp[i].tipo == 'marca') {
        this.prService.getIdFabrProdHashtag(temp[i]).subscribe(result => {
          this.idProducto = result;
          this.tempRelFabMarca = [temp[i].label, this.idProducto];
          this.tempMarca.push(this.tempRelFabMarca);
        });

      } else {
        this.tempNormal.push(temp[i]);
      }
    }

    this.plato.tagsMarca = this.tempMarca;
    this.plato.tagsNormal = this.tempNormal;
    this.plato.alergenos = JSON.parse(this.plato.alergenos);

    this.arrayBotones = GLOBAL.arrayBotones(this.slugRest);
    let currentUrl = window.location.href;

    if (currentUrl.indexOf("QR") != -1) {
      this.cartaQR = true;
      this.arrayBotones = GLOBAL.arrayBotonesQR(this.establecimiento.id);
    }

    this.traducir();

    this.establecimiento.horario = [];

    this.diasSemana.forEach((dia, index) => {
      this.establecimiento.horario[index] = this.establecimiento["horario_" + dia];
    });

    this.pService.getOtrosHashTags(this.plato.id).subscribe(result => {
      this.otros_hashtag = result;
    });
  }

  traducir = () => {


    if (this.lang != "es") {

      if (this.plato["traduccion"][this.lang] != undefined) {

        let tradNombrePlato = this.plato["traduccion"][this.lang].nombre_plato;

        if (tradNombrePlato != "" && tradNombrePlato != null) {
          this.plato.nombre_plato = tradNombrePlato;
        }

        let tradDescripcion = this.plato["traduccion"][this.lang].descripcion;

        if (tradDescripcion != "" && tradDescripcion != null && tradDescripcion != '[{\"data\": \"\"}]') {
          this.plato.descripcion = JSON.parse(tradDescripcion)[0].data;
        }

      }

      if (this.restauranteModel["traduccion"][this.lang] != undefined) {
        let tradNombre = this.restauranteModel["traduccion"][this.lang].nombre;

        if (tradNombre != "" && tradNombre != null) {
          this.nombreRest = tradNombre;
        }
      }

    }

  }

  // ABRIR | CERRAR MODAL EDICIÓN INFO
  open(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

      if (this.listTagNormal) {
        for (let i = 0; i < this.listTagNormal.length; i++) {
          this.plato.tagsNormal.push(this.listTagNormal[i]);
        }
      }
      // ENVIAR INFO PLATO A LARAVEL
      this.pService.editInfoPlato(this.plato).subscribe(result => {
      });
      this.tempNormal = [];
      this.tempMarca = [];
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  // AÑADIR NUEVO TAG NORMAL 
  addNuevoTag(tag) {
    let t = new Tags;
    t.tipo = 'normal';
    t.label = tag;
    this.listTagNormal.push(t);
    this.newTagNormal = '';
  }

  
}
